// All action times

const manageIpAddress = {
  REQUEST_UPDATEIPADDRESS: 'REQUEST_UPDATEIPADDRESS',
  RECEIVE_UPDATEIPADDRESS: 'RECEIVE_UPDATEIPADDRESS',
  ERROR_UPDATEIPADDRESS: 'ERROR_UPDATEIPADDRESS'
}

export default manageIpAddress



// WEBPACK FOOTER //
// src/routes/ManageIpAddress/actions/actionTypes.js